export default __webpack_public_path__ + "maps-guides-view-annotation-selected-1200-9d8c074e800c971656bef777734e56d1.png";